export const environment = {
    environment: 'release',
    rootPublicUrl: 'https://lsr.is/',
    localApi: 'https://api-portal-release.lsr.is/api/',
    refreshTokenTimeAnotherUser: 10,
    refreshTokenTime: 20160,
    refreshTokenTimeWarning: 20155,
    powerBIStjornWorkspaceId: '88f57a56-e5e6-4048-bec3-b0c675c623fe',
    powerBIAlmenntWorkspaceId: 'd4e05fbb-67e3-4a36-929d-14eb104d5382',
    googleAnalyticsGtag: '',
    coredataPortalUrl: 'https://portal.coredata.is/lsr',
    libraPortalUrl: 'https://libra-ebank-test.lsr.is',
    pensionCalculatorUrl: 'https://lifeyrisreiknivel-dev.lsr.is/',
    customerPortalUrl: 'https://mitt-release.lsr.is/',

    // Jira links
    jiraIncidentUrl: 'https://lsr.atlassian.net/servicedesk/customer/portal/6/group/43/create/272',
    jiraNewEmployeeAccessUrl: 'https://lsr.atlassian.net/servicedesk/customer/portal/10/group/49/create/206',

    // Jira project ids
    jiraProjectUT: 'UT',

    // Jira request types
    jiraRequestTypeNewEmployeeAccess: 206,
};
